import { Fragment, ReactNode } from 'react';
import { FormControl, FormLabel } from '@chakra-ui/react';
import { FormError } from '../DashLayout/FormError';

type CampoFormProps = {
	label: string;
	/** Deve casar com o id do Input/Select filho para o label continuar clicavel. */
	htmlFor?: string;
	erro?: string;
	isRequired?: boolean;
	/**
	 * Esconde o asterisco sem abrir mao do aria-required. Serve para telas onde
	 * todo campo e obrigatorio (login, recuperacao de senha): sem nenhum campo
	 * opcional para contrastar, o asterisco nao informa nada.
	 */
	ocultarAsterisco?: boolean;
	/** Para as telas de autenticacao, que ficam sobre o card escuro. */
	labelColor?: string;
	children: ReactNode;
};

/**
 * Envolve um campo de formulario com label, marcacao de obrigatorio e erro
 * inline. O asterisco e o aria-required vem do proprio FormControl, entao nenhum
 * label precisa escrever " *" na mao.
 */
export const CampoForm = ({
	label,
	htmlFor,
	erro,
	isRequired = true,
	ocultarAsterisco,
	labelColor,
	children
}: CampoFormProps) => {
	return (
		<FormControl isRequired={isRequired} isInvalid={!!erro}>
			<FormLabel
				htmlFor={htmlFor}
				color={labelColor}
				requiredIndicator={ocultarAsterisco ? <Fragment /> : undefined}
			>
				{label}
			</FormLabel>
			{children}
			{erro && <FormError text={erro} />}
		</FormControl>
	);
};
